window.nfpetsConfig = {
    network: "MainNet",
    walletConnect: {
        infuraId: "ac09d5abb9154f3ba86442116998be8f",
    },
    chains: {
        "0x1": {
            network: "MainNet", name: "Ethereum", networkId: 1, aggregator: {
                enabled: true,
                address: '0x7985e6ac13799ca1a31007f54c115f5b68c6aa3f',
            }, default: true
        }
    },
    pets: {
        sparky: "0xf34893e893BE01015E7c1F533075135785e9470E",
        super: "0xD000773d474b838517302427e015E84c2D869044",
        nfp: "0x92133e21fff525b16d1edcf78be82297d25d1154"
    }
}
